// Keep this as plain JS so you can add comments. You can also convert to .json.
const HEADER_RSLHOME = {
    logo: { src: "/img/general/logo-dark_rsl.svg", href: "/" },
    logo_white: { src: "/img/general/logo-white_rsl.svg", href: "/" },

    // Center nav
    nav: [
        { type: "link", label: "About us", href: "/about-rsl" },
        { type: "link", label: "Be An Investor", href: "/investments/investments" },
        { type: "link", label: "Register for B2B Access", href: "/info/supplierPartnerb2b?type=1" },
        // {
        //     type: "menu",
        //     label: "Register for B2B Access",
        //     items: [
        //         { label: "Register as B2B corporate", href: "/info/supplierPartnerb2b?type=1" },
        //         { type: "divider" },
        //         { label: "Web Booker", href: "/web-booker" }
        //     ]
        // },
        // {
        //     type: "menu",
        //     label: "Franchise",
        //     items: [
        //         { label: "Franchise Profile", href: "/company-profile", target: true },
        //         { label: "Franchise FAQ's", href: "/franchise-faq", target: true }
        //     ]
        // },
        { type: "link", label: "All Services", href: "/all-services" },
        { type: "link", label: "Collaborate With Us", href: "/investments/collaborate" },
        // { type: "link", label: "Blogs", href: "/blogs" },
        { type: "link", label: "Become A Supplier", href: "/supplier" }
    ],
    services: [
        // {
        //     "id": 1,
        //     "name": "CAB",
        //     "key": "Cab",
        //     "icon": "/img/filtericons/cars.svg",
        //     "url": "cab",
        //     "visibility": true
        // },
        // {
        //     "id": 1,
        //     "name": "FLIGHTS",
        //     "key": "Flights",
        //     "icon": "/img/filtericons/flight.svg",
        //     "url": "flights",
        //     "visibility": true
        // },
        // {
        //     "id": 2,
        //     "name": "HOTELS",
        //     "key": "Hotels",
        //     "icon": "/img/filtericons/hotel.svg",
        //     "url": "hotels",
        //     "visibility": true
        // },
        {
            "id": 3,
            "name": "ACTIVITIES",
            "key": "Activities",
            "icon": "/img/filtericons/tickets.svg",
            "url": "activities",
            "visibility": true,
            type: "link",
            label: "ACTIVITIES",
            href: "/activities"
        },
        {
            "id": 6,
            "name": "HOLIDAYS",
            "key": "Holidays",
            "icon": "/img/filtericons/holidays.svg",
            "url": "holidays",
            "visibility": true,
            type: "link",
            label: "HOLIDAYS",
            href: "/holidays"
        },
        // {
        //     "id": 7,
        //     "name": "STAYCATION",
        //     "key": "Staycations",
        //     "icon": "/img/filtericons/staycation.svg",
        //     "url": "staycations",
        //     "visibility": true
        // },
        // {
        //     "id": 5,
        //     "name": "BUSES",
        //     "key": "Buses",
        //     "icon": "/img/filtericons/buses.svg",
        //     "url": "buses",
        //     "visibility": true
        // },
        {
            "id": 6,
            "name": "VISA",
            "key": "VisaServices",
            "icon": "/img/filtericons/visaservice.svg",
            "url": "visa-service/visaService",
            "visibility": true,
            type: "link",
            label: "VISA",
            href: "/visa-service/0"
        }
    ],
    // Right side widgets
    search: { enabled: true, placeholder: "Search..." },

    appBadges: {
        enabled: true,
        label: "Get the app",
        stores: [
            { type: "apple", href: "https://apps.apple.com/in/app/rsl-car-booking-service/id1351219496", img: "/img/header/appstore.svg" },
            { type: "android", href: "https://play.google.com/store/apps/details?id=com.rsl.luxurycab.passenger", img: "/img/header/playstore.svg" }
        ]
    },

    cta: { label: "Log in", href: "/" } // leave href empty to keep as button only
};

export default HEADER_RSLHOME;
